import React from 'react';
import styles from './BlazeDropdown.module.css';
import imageSrc from '../../../../assets/img/loader.gif';
import clsx from 'clsx';
import { handleFocus } from '../../../../utils/commonUtil';

interface BlazeDropdownToggleProps {
  onClick: (e: any) => void;
  isLoadingButton: any;
  disabled: boolean;
  style: any;
  id: any;
  focus: boolean;
  innerRef: any;
}

/**
 * Custom toggle for the React Dropdown. It is needed just to have custom mark up.
 */
class BlazeDropdownToggle extends React.Component<BlazeDropdownToggleProps> {
  constructor(props: any, context: any) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  toggleRef: React.RefObject<any> = React.createRef();

  componentDidMount() {
    if (this.props.focus === true) {
      handleFocus(this.toggleRef.current);
    }
  }

  handleClick(e: any) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    const { id, style } = this.props;
    return (
      <button
        id={id}
        className={clsx('text-truncate', 'form-control', 'custom-select', styles.button)}
        ref={this.props.innerRef}
        disabled={this.props.disabled}
        style={style}
        onClick={(e: any) => {
          e.preventDefault();
          this.props.onClick(e);
        }}
      >
        {this.props.isLoadingButton ? 'Upgrading' : this.props.children}
        {this.props.isLoadingButton && (
          <img style={{ marginLeft: '10px' }} src={imageSrc} alt="please wait while upgrading" height={20} width={20} />
        )}
      </button>
    );
  }
}

export default React.forwardRef((props: any, ref) => <BlazeDropdownToggle innerRef={ref} {...props} />);
